import { groupBy, chunk, orderBy } from "lodash";
import { LK_FILTER_VALUE, Region } from "../config";

export const generateMagazineClassfications = ({ dataset }) => {
  const output = {};
  const genderClassification = groupBy(dataset, (element) => element.gender);
  for (const [gender, valueSet] of Object.entries(genderClassification)) {
    output[gender] = {};
    let regionClassification = groupBy(valueSet, (element) =>
      element.resCountry === "Sri Lanka" ? Region.LK : Region.NON_LK
    );
    for (const [region, regionDataset] of Object.entries(
      regionClassification
    )) {
      if (region === Region.LK) {
        const districtClassification = groupBy(
          regionDataset,
          (element) => element.resDistrict
        );
        output[gender][region] = districtClassification;
        continue;
      }
      const countryClassification = groupBy(
        regionDataset,
        (element) => element.resCountry
      );
      output[gender][region] = countryClassification;
    }
  }

  const orderingMap = {};
  for (const [gender, genderDataMap] of Object.entries(output)) {
    if (orderingMap[gender] === undefined) {
      orderingMap[gender] = {};
    }
    for (const [location, locationData] of Object.entries(genderDataMap)) {
      if (orderingMap[gender][location] === undefined) {
        orderingMap[gender][location] = [];
      }
      for (const [region, regionData] of Object.entries(locationData)) {
        const orderingObj = {
          location: region,
          size: Array.isArray(regionData) ? regionData.length : 0,
        };
        if (Array.isArray(orderingMap[gender][location])) {
          orderingMap[gender][location].push(orderingObj);
        }
      }
      orderingMap[gender][location] = orderBy(
        orderingMap[gender][location],
        ["size"],
        ["desc"]
      );
    }
  }

  const orderedOutput = {};

  for (const [gender, genderData] of Object.entries(orderingMap)) {
    orderedOutput[gender] = orderedOutput[gender] || {};
    for (const [region, orderMeta] of Object.entries(genderData)) {
      orderedOutput[gender][region] = orderedOutput[gender][region] || {};
      for (const current of orderMeta) {
        orderedOutput[gender][region][current.location] =
          output[gender][region][current.location];
      }
    }
  }

  return orderedOutput;
};

export const generateMagazineTemplate = ({
  generatorMap,
  rows,
  columns,
  genderPriority,
  regionPriority,
  locationMeta,
}) => {
  const template = [];
  for (const gender of genderPriority) {
    template[gender] = [];
    for (const region of regionPriority) {
      const regionDataset = generatorMap[gender][region];
      const subRegions = Object.keys(regionDataset);
      for (let current = 0; current < subRegions.length; current++) {
        const currentLocation = subRegions[current];
        const locationSeparator = {
          isLocationSeparator: true,
          locationHeading: locationMeta[region]["regions"][currentLocation],
          mainHeading: current === 0 ? locationMeta[region] : undefined,
        };
        const locationDataset = regionDataset[currentLocation];
        const outputArray = [locationSeparator, ...locationDataset];

        const pushedArray = template[gender];
        pushedArray.push(...outputArray);
      }
    }
  }
  // constructing final template
  const finalTemplate = {};
  for (const [gender, advertisments] of Object.entries(template)) {
    finalTemplate[gender] = [];

    if (!Array.isArray(advertisments)) {
      break;
    }
    // first page chunk
    const noOfAdsFirstPage = columns * (rows - 1);
    const noOfAdRestPage = columns * rows;
    const iterations = Math.ceil(
      (advertisments.length - noOfAdsFirstPage) / noOfAdRestPage
    );

    // column end indexes
    const columnEndIndices = [];
    // first page column end indexes
    for (let current = 1; current <= columns; current++) {
      const columnEndIndex = current * (rows - 1) - 1;
      columnEndIndices.push(columnEndIndex);
    }
    // rest page column end indexes
    const firstPageOffset = noOfAdsFirstPage - 1;
    for (let current = 1; current <= iterations; current++) {
      const restPagesOffset = (current - 1) * noOfAdRestPage;
      for (let currentColumn = 1; currentColumn <= columns; currentColumn++) {
        let columnEndIndex =
          firstPageOffset + restPagesOffset + currentColumn * rows;
        columnEndIndices.push(columnEndIndex);
      }
    }
    const tempArray = Array.from(advertisments);
    for (const columnEndIndex of columnEndIndices) {
      const advertisment = tempArray[columnEndIndex];
      if (advertisment && advertisment.isLocationSeparator) {
        tempArray.splice(columnEndIndex, 0, { columnEndPlaceholder: true });
      }
    }
    const firstPageAds = tempArray.slice(0, noOfAdsFirstPage);
    const nextChunks = chunk(
      tempArray.slice(noOfAdsFirstPage),
      noOfAdRestPage
    );
    finalTemplate[gender] = [firstPageAds, ...nextChunks]
  }
  return finalTemplate;
};

export const generateLocationMeta = ({ dataset }) => {
  const locationMeta = {};
  for (const element of dataset) {
    const { resCountry, resCountrySi } = element;
    if (resCountry === LK_FILTER_VALUE) {
      if (locationMeta[Region.LK] === undefined) {
        locationMeta[Region.LK] = {
          locationNameEN: resCountry,
          locationNameSI: resCountrySi,
          regions: {},
        };
      }
      const { resDistrict, resDistrictSi } = element;
      if (locationMeta[Region.LK]["regions"][resDistrict] === undefined) {
        locationMeta[Region.LK][["regions"]][resDistrict] = {
          locationNameEN: resDistrict,
          locationNameSI: resDistrictSi,
        };
      }
    } else {
      if (locationMeta[Region.NON_LK] === undefined) {
        locationMeta[Region.NON_LK] = {
          locationNameEN: "Overseas",
          locationNameSI: "විදේශීය",
          regions: {},
        };
      }
      if (locationMeta[Region.NON_LK]["regions"][resCountry] === undefined) {
        locationMeta[Region.NON_LK]["regions"][resCountry] = {
          locationNameEN: resCountry,
          locationNameSI: resCountrySi,
        };
      }
    }
  }

  return locationMeta;
};
